import type { ReactNode } from "react";
import { SageSidebar } from "./SageSidebar";

/** The frame around every signed-in page: the sidebar, and the page beside it. */
export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen w-full flex-1 flex-col self-stretch md:flex-row">
      <SageSidebar />
      <div className="flex min-w-0 flex-1 flex-col items-center gap-6 py-8">{children}</div>
    </div>
  );
}
